import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Breadcrumbs } from 'src/app/shared/models/breadcrumbs';
import { SupplierProfile } from 'src/app/shared/models/supplier-profile';
import { DataService } from 'src/app/shared/services/data-service/data.service';
import { StoreService } from 'src/app/shared/services/store-service/store.service';

@Component({
  standalone: false,
  selector: 'app-view-supplier-profile',
  templateUrl: './view-supplier-profile.component.html',
  styleUrls: ['./view-supplier-profile.component.scss'],
})
export class ViewSupplierProfileComponent implements OnInit {
  currentSupplierProfile: SupplierProfile[];
  supplierIdentity: string;
  supplierName: string;
  searchString: string = '';
  breadcrumbItems: Breadcrumbs[];
  loading = true;

  constructor(
    public storeService: StoreService,
    private dataService: DataService,
    private router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    let supplierFromURL = this.router.url.split('/').pop();

    // Get supplier profile
    await this.dataService.initSupplierProfiles();

    // Get current supplier profile
    this.currentSupplierProfile = this.storeService.supplierProfiles.filter(
      (x) => x.supplierIdentity === supplierFromURL
    );
    this.supplierIdentity = this.currentSupplierProfile[0].supplierIdentity;
    this.supplierName = this.currentSupplierProfile[0].supplierName;

    this.buildBreadcrumbs();
    this.loading = false;

    this.getPlantVendorDescription();
  }

  buildBreadcrumbs() {
    this.breadcrumbItems = [
      {
        text: 'Supplier Profile',
        link: '/supplier-profile',
      },
      {
        text: this.supplierIdentity,
        link: '/supplier-profile/' + this.supplierIdentity,
      },
    ];
  }

  getPlantVendorDescription() {
    this.currentSupplierProfile.forEach(async (profile) => {
      if (!profile.plantDescription && profile.plantCode)
        profile.plantDescription = await this.dataService.getPlantDescription(
          profile.plantCode
        );
      if (!profile.vendDescription && profile.vendCode)
        profile.vendDescription = await this.dataService.getVendorDescription(
          profile.vendCode
        );
    });
  }

  clearSearch() {
    this.searchString = '';
  }

  delete(profile: SupplierProfile) {
    if (
      confirm('Are you sure to remove this vendor: ' + profile.vendCode + '?')
    ) {
      this.currentSupplierProfile = this.currentSupplierProfile.filter(
        (pf) =>
          !(
            pf.supplierIdentity === profile.supplierIdentity &&
            pf.plantCode === profile.plantCode &&
            pf.vendCode === profile.vendCode
          )
      );

      // Delete profile
      this.dataService.deleteProfile(profile);
      // delete data store
      this.storeService.deleteSupplierProfile(profile);

      if (this.currentSupplierProfile.length == 0) {
        // delete data store
        this.storeService.deleteSupplierList(profile);
        // Navigate back to list page
        this.router.navigate(['/supplier-profile/']);
      }
    }
  }
}

